<template>
  <v-card
    :min-height="minh"
    :outlined="isoutlined"
    :tile="istile"
    :dark="isdark"
    :color="color">
    <slot name="header">
      <v-sheet class="pl-4 d-flex justify-start align-center" height="40" color="light-blue darken-3 white--text">
        <v-icon color="white">mdi-newspaper-variant-outline</v-icon>
        <div class="divider"></div>
        <span class="text-button">{{newsbartitle}}</span>
      </v-sheet>
    </slot>
    <slot name="img">
    </slot>
    <div>
      <v-overlay opacity="0.2" absolute :value="loading">
        <v-progress-circular indeterminate color="light-blue" width="3" size="30"></v-progress-circular>
      </v-overlay>
      <div v-for="i in newslist" :key="i.id" class="newsitem">
        <div class="newstitle text-subtitle-2"><v-icon small class="mr-2">mdi-chevron-double-right</v-icon><a class="text-truncate" @click="item_click(i.id)">{{i[$store.state.lang+'_title']}}</a></div>
        <div class="newsdate text-overline"><span>{{i.crtime.slice(0,10)}}</span></div>
      </div>
    </div>
    <v-card-actions class="d-flex justify-end">
      <v-btn @click="$router.push('/newslist?flag=5&ischild=false')" text dark color="primary">more</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default{
  name:'newsbar',
  data(){
    return{
      newsbar_io_api:'newsbar/io/',
      newslist:[],
      limit:3,
      loading:false,
      newslist_id:5,
    }
  },
  props:{
    color:{
      type:String,
      default:'grey lighten-5',
    },
    minh:{
      type:Number,
      default:100,
    },
    isdark:{
      type:Boolean,
      default:false,
    },
    istile:{
      type:Boolean,
      default:false,
    },
    isoutlined:{
      type:Boolean,
      default:false,
    },
  },
  computed:{
    newsbartitle(){
      let tmp = '';
      if(this.$store.state.lang == 'cn'){
        tmp = '新闻中心';
      }else{
        tmp = 'News Center';
      }
      return tmp
    },
  },
  methods:{
    item_click(id){
      this.$router.push({
        path:'/newslist',
        query:{
          flag:5,
          ischild:'true',
          childid:id,
        },
      });
    },
    fetch(){
      this.loading = true;
      let postdata = {};
      postdata.limit = this.limit;
      this.$axios.post(this.$store.state.baseurl + this.newsbar_io_api,postdata)
          .then(
            response => {
              if(response.data.err == '0'){
                this.newslist = response.data.data;
                this.loading = false;
              }
            }
          )
          .catch(function (e){})
    },
  },
  mounted(){
    this.fetch();
  },
}
</script>

<style scoped>
.divider{
  height:50%;
  width:2px;
  background:#fff;
  margin:0 8px;
}
.newsitem{
  max-height:45px;
  border-bottom:1px solid #eee;
  margin-top:4px;
}
.newstitle{
  display:flex;
  align-items:center;
  margin-left:10px;
  color:#345;
}
.newsdate{
  font-style:italic;
  text-align:right;
  margin-right:8px;
  color:#678;
}
</style>